import { Box, Skeleton } from "@mui/material";
export const SkeletonNotifications = () => {

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: 2,

                width: '100%',
                gap: 2,
            }}
        >
            {/* Bullet skeleton */}
            <Skeleton variant="circular" width={12} height={12} sx={{ mr: 2 }} />
            {/* Thumbnail skeleton */}
            <Skeleton
                variant="rectangular"
                sx={{
                    borderRadius: 2,
                    mr: 2,
                    flexShrink: 0,
                    width: 100,
                    height: 100,

                }}
            />
            {/* Text skeletons */}
            <Box flex={1}>
                <Skeleton width="60%" height={24} sx={{ mb: 1 }} />
                <Skeleton width="20%" height={18} sx={{ mb: 0.5 }} />
                <Skeleton width="10%" height={14} />
            </Box>
        </Box>
    )
};
